<template>
  <div class="dark:bg-gray-900 dark:text-gray-200 py-12">

    <QuestDiv></QuestDiv>
  </div>
</template>

<script>

import QuestDiv from "@/components/quest/QuestDiv.vue";
export default {
  name: "QuestsView",
  components: { QuestDiv },
};
</script>
